import { MutationTree } from "vuex";
import { ActivityLogState, SelectedSite } from "./types";

export const mutations: MutationTree<ActivityLogState> = {
    setSelectedSites(state, sites: SelectedSite[]) {
		  state.selectedSites = sites;
    },
    addSelectedSite(state, site: SelectedSite) {
		  state.selectedSites.push(site);
    },
    removeSelectedSite(state, site: SelectedSite) {
      const siteIndex: number = state.selectedSites.indexOf(site);
      state.selectedSites.splice(siteIndex,1);
    },
};
